module.exports = __webpack_public_path__ + "img/Board-min.750a7a3f.png";